"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.redirectTo = exports.buildLineAuthorizeUrl = exports.buildLineRedirectUri = exports.generateRandomToken = exports.LINE_NONCE_STORAGE_KEY = exports.LINE_STATE_STORAGE_KEY = exports.LINE_AUTHORIZE_URL = void 0;
var appConfig_1 = __importDefault(require("../config/appConfig"));
var path_1 = require("../definition/path");
exports.LINE_AUTHORIZE_URL = "https://access.line.me/oauth2/v2.1/authorize";
exports.LINE_STATE_STORAGE_KEY = "pos.socialAuth.lineState";
exports.LINE_NONCE_STORAGE_KEY = "pos.socialAuth.lineNonce";
var MARKETPLACE_BASE_PATH = "/marketplace/web";
var generateRandomToken = function () {
    var cryptoApi = window.crypto;
    if (cryptoApi && typeof cryptoApi.getRandomValues === "function") {
        var buffer = new Uint8Array(16);
        cryptoApi.getRandomValues(buffer);
        return Array.from(buffer)
            .map(function (value) { return value.toString(16).padStart(2, "0"); })
            .join("");
    }
    return "".concat(Date.now().toString(16)).concat(Math.random().toString(16).slice(2));
};
exports.generateRandomToken = generateRandomToken;
var buildLineRedirectUri = function () {
    var configured = appConfig_1.default.getLineRedirectUri();
    if (configured) {
        return configured;
    }
    var basePath = window.location.pathname.startsWith(MARKETPLACE_BASE_PATH)
        ? MARKETPLACE_BASE_PATH
        : "";
    return "".concat(window.location.origin).concat(basePath).concat(path_1.Page.LineCallbackPage);
};
exports.buildLineRedirectUri = buildLineRedirectUri;
var buildLineAuthorizeUrl = function (params) {
    var query = new URLSearchParams({
        response_type: "code",
        client_id: params.channelId,
        redirect_uri: params.redirectUri,
        state: params.state,
        scope: "profile openid email",
        nonce: params.nonce
    });
    return "".concat(exports.LINE_AUTHORIZE_URL, "?").concat(query.toString());
};
exports.buildLineAuthorizeUrl = buildLineAuthorizeUrl;
var redirectTo = function (url) {
    window.location.assign(url);
};
exports.redirectTo = redirectTo;
